





















import { defineComponent, ref, watch } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'
import { ApplicationChiclets } from '~/types/product/productTypes'
import { useMobile } from '@/composables/ui/useMobile'
export default defineComponent({
  props: {
    applicationChiclets: {
      type: Array as () => ApplicationChiclets,
      required: true,
    },
    activeChiclet: {
      type: String,
      required: false,
      default: null,
    },
  },
  emits: ['chicletClick'],
  setup(props, { emit }) {
    const { isMobile } = useMobile()

    const isSingleChiclet = props.applicationChiclets.length === 1
    const clickedChiclet = ref<string | null>(props.activeChiclet)

    const onChicletClick = (application: string) => {
      if (!isSingleChiclet) {
        clickedChiclet.value === application ? (clickedChiclet.value = null) : (clickedChiclet.value = application)
        emit('chicletClick', clickedChiclet.value)
      }
    }
    watch(props, () => {
      clickedChiclet.value = props.activeChiclet
    })
    return { isEmpty, isMobile, onChicletClick, clickedChiclet, isSingleChiclet }
  },
})
